const experienceData = [
  {
    id: 1,
    position: "Soporte y Organización",
    company: "OfficePlus Solutions",
    period: "Abril 2024 – Diciembre 2024",
    description: "Soporte técnico de la empresa y mantenimiento.",
    responsibilities: [
      "Soporte técnico especializado",
      "Mantenimiento de sistemas",
      "Organización de procesos técnicos"
    ]
  },
  {
    id: 2,
    position: "Desarrollador Full-Stack",
    company: "Gimnasio Center Fit",
    period: "Abril 2025 – Presente",
    description: "Desarrollo de un sitio web full-stack para un gimnasio local.",
    responsibilities: [
      "Desarrollo frontend y backend",
      "Integración de gestión de usuarios",
      "Implementación de sistemas de reservas"
    ],
    url: "https://centerfit.vercel.app/"
  }
];

export default experienceData;